import { Role } from '../types/enums/Role.enum';

export const canAccessTargetUser = (
  targetUserRole: Role,
  activeUserRole: Role,
): boolean => {
  return (
    (targetUserRole === Role.SystemAdministrator &&
      !hasSystemAdminAccess(activeUserRole)) ||
    (targetUserRole === Role.ClientSystemAdministrator &&
      !hasClientSystemAdminAccess(activeUserRole))
  );
};

export const hasAdminAccess = (role: Role): boolean => {
  return [
    Role.Administrator,
    Role.ClientSystemAdministrator,
    Role.OrgGroupAdministrator,
    Role.SystemAdministrator,
  ].includes(role);
};

export const hasClientSystemAdminAccess = (role: Role): boolean => {
  return [Role.ClientSystemAdministrator, Role.SystemAdministrator].includes(
    role,
  );
};

export const hasOrgSwitchingAccess = (role: Role): boolean => {
  return [
    Role.ClientSystemAdministrator,
    Role.OrgGroupAdministrator,
    Role.OrgGroupUser,
    Role.SystemAdministrator,
  ].includes(role);
};

export const hasReadOnlyAccess = (role: Role): boolean => {
  return role === Role.ReadOnly;
};

export const hasSystemAdminAccess = (role: Role): boolean => {
  return role === Role.SystemAdministrator;
};

export const hasUserAccess = (role: Role): boolean => {
  return role !== Role.ReadOnly;
};
